import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Link } from 'react-router-dom';

import "./styles.scss";

const MenuCategory = (props) => {
    const {
        categoryIcon,
        categoryName,
        links,
        hovered,
        hoverOutSidebar,
        isActive,
        defaultCollapsed = true,
        expandedCategory,
        setExpandedCategory,
        categoryId
    } = props;

    const location = useLocation();
    const [expandedItem, setExpandedItem] = useState(null);

    // Close dropdown when location changes
    useEffect(() => {
        // If we're on the tag monitor page, expand its submenu
        if (location.pathname === '/tag_monitor_dashboard') {
            setExpandedItem('Tag Monitor');
        } else {
            setExpandedItem(null);
        }
    }, [location.pathname]);

    const handleCategoryClick = () => {
        if (expandedCategory === categoryId) {
            setExpandedCategory(null);
        } else {
            setExpandedCategory(categoryId);
        }
    };
    
    const handleItemClick = (itemName, event) => {
        event.preventDefault();
        setExpandedItem(expandedItem === itemName ? null : itemName);
    };

    const isSubLinkActive = (to) => {
        if (!to) return false;
        const searchParams = new URLSearchParams(location.search);
        const currentView = searchParams.get('view') || 'client';
        return to.toLowerCase() === currentView.toLowerCase();
    };

    const getActiveView = () => {
        const searchParams = new URLSearchParams(location.search);
        return searchParams.get('view') || 'client';
    };

    // Function to check if a link is active based on the current path
    const isLinkActive = (to) => {
        if (!to) return false;
        // Special case for homepage - don't highlight any links
        if (location.pathname === '/') {
            return false;
        }
        // For other paths, check if the current path matches the link's path
        return location.pathname === to;
    };

    // Check if any link in this category is active
    const hasActiveLink = () => {
        // Special case for homepage - don't highlight any category
        if (location.pathname === '/') {
            return false;
        }
        
        return links.some(link => {
            if (link.children) {
                return isLinkActive(link.to) || link.children.some(child => {
                    const childPath = child.to.split('?')[0];
                    return location.pathname === childPath;
                });
            }
            return isLinkActive(link.to);
        });
    };

    // Use the isActive prop if provided, otherwise fall back to hasActiveLink
    const isCategoryActive = isActive !== undefined ? isActive : hasActiveLink();

    const menuElems = links.map(elem => {
        if (elem.children) {
            const isActive = isLinkActive(elem.to);
            return (
                <div key={elem.name} className={`sidebar-elems-link ${elem?.active ? "" : "disabled"}`}>
                    <div 
                        className={`parent-link ${expandedItem === elem.name ? 'expanded' : ''} ${isActive ? 'active' : ''}`}
                        onClick={(e) => handleItemClick(elem.name, e)}
                    >
                        <span className="title-sliding">{elem.name}</span>
                    </div>
                    <div 
                        className={`sidebar-sub-links ${expandedItem === elem.name ? 'expanded' : ''}`}
                        data-active={getActiveView()}
                    >
                        {elem.children.map(child => (
                            <Link 
                                key={child.name} 
                                to={child.to || '#'} 
                                className={`sub-link ${isSubLinkActive(child.name.toLowerCase().split(' ')[0]) ? 'active' : ''}`}
                                onClick={(e) => {
                                    if (child.disabled) {
                                        e.preventDefault();
                                        return;
                                    }
                                    setExpandedItem(elem.name);
                                }}
                            >
                                <span style={{ fontSize: "12px" }}>{child.name}</span>
                            </Link>
                        ))}
                    </div>
                </div>
            );
        }
        const isActive = isLinkActive(elem.to);
        return (
            <Link 
                key={elem.name} 
                to={elem.disabled ? '#' : elem.to} 
                onClick={(e) => {
                    if (elem.disabled) {
                        e.preventDefault();
                        return;
                    }
                    hoverOutSidebar();
                }}
                className={`sidebar-elems-link ${elem?.active ? "" : "disabled"} ${isActive ? 'active' : ''}`}
            >
                <span className="title-sliding" style={{ fontSize: "14px" }}>{elem.name}</span>
            </Link>
        );
    });

    return (
        <div className="sidebar-menu-category">
            <div className="sidebar-category-container" onClick={handleCategoryClick}>
                <div className="category-icon">
                    {categoryIcon}
                </div>
                <div className="sidebar-category-name title-sliding">{categoryName}</div>
            </div>
            <div className={`sidebar-elems-container ${(expandedCategory === categoryId && hovered) ? 'expanded' : ''}`}>
                <div className={`sidebar-elems-grid`}>
                    {menuElems}
                </div>
            </div>
        </div>
    );
};

export default MenuCategory;